// extracted by mini-css-extract-plugin
module.exports = {"homeLogo":"signup_homeLogo__Q6Kqw"};